<template>
  <div>
    <div class="member_balance_box">
      <div class="member_balance_header">
        <p class="t1">我的积分</p>
        <p class="t2"><span style="color:#666;font-size:14px;">可用&nbsp;&nbsp;&nbsp;&nbsp;</span>{{score}}<span class="slash"></span><span style="color:#666;font-size:14px;">过期&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="color:#18b975;">{{overdueScore}}</span></p>
      </div>
      <div class="member_balance_search">
        <ul class="clearfix_">
          <li class="clearfix_ fl">
            <span class="fl">时间：</span>
            <el-form class="fl" style="height:40px;margin-right:30px;">
              <el-form-item>
                <el-date-picker
                  v-model="startTime"
                  type="date"
                  format="yyyy-MM-dd"
                  @change="getStartTime"
                  value-format="yyyy-MM-dd"
                  placeholder="">
                </el-date-picker>
              </el-form-item>
            </el-form>
            <el-form class="fl" style="height:40px;margin-right:30px;">
              <el-form-item>
                <el-date-picker
                  v-model="endTime"
                  type="date"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  @change="getEndTime"
                  placeholder="">
                </el-date-picker>
              </el-form-item>
            </el-form>
          </li>
          <li class="clearfix_ fl">
            <span class="fl">资金流向：</span>
            <el-select style="width:142px;margin-right:30px;" v-model="moneyFlows" placeholder="请选择">
              <el-option label="全部" value="0"> </el-option>
              <el-option label="收入" value="1"> </el-option>
              <el-option label="支出" value="2"> </el-option>
            </el-select> 
          </li>
          <li class="clearfix_ fl">
            <span class="fl">单据类型：</span>
            <el-select style="width:142px;margin-right:30px;" v-model="billType" placeholder="请选择">
              <el-option label="全部" value="0"> </el-option>
              <el-option label="消费" value="1"> </el-option>
              <el-option label="退货" value="2"> </el-option>
              <el-option label="积分兑换" value="3"> </el-option>
              <el-option label="积分充值" value="4"> </el-option>
              <el-option label="报名积分" value="5"> </el-option>
            </el-select>
          </li>
          <li class="clearfix_ fr"><button @click="searchFn">搜索</button></li>
        </ul>
        <div class="clearfix_ member_balance_search_total">
          <p class="fl income">收入：&nbsp;&nbsp;&nbsp;&nbsp;<span style="color:#e32219;font-size:18px;">{{income}}</span></p>
          <p class="fl expenditure">支出：&nbsp;&nbsp;&nbsp;&nbsp;<span style="color:#18b975;font-size:18px;">{{spending}}</span></p>
        </div>
      </div>
      <div class="member_balance_content">
        <h2 class="clearfix_">
          <p class="fl">单据编号</p>
          <p class="fl">单据时间</p>
          <p class="fl">单据类型</p>
          <p class="fl">收入/支出（分）</p>
        </h2>
        <ul>
          <li v-for="(item,index) in memberScoreList" :key="index" class="clearfix_">
            <p class="fl">{{item.scode}}</p>
            <p class="fl">{{item.dateCreated}}</p>
            <p class="fl">
              {{item.type=='33'?'积分兑换':''}}
              {{item.type=='44'?'积分充值':''}}
              {{item.type=='11'?'POS零售消费':''}}
              {{item.type=='12'?'PC消费':''}}
              {{item.type=='13'?'微信消费':''}}
              {{item.type=='14'?'app消费':''}}
              {{item.type=='21'?'电商退货':''}}
              {{item.type=='22'?'POS零售退货':''}}
              {{item.type=='23'?'app退货':''}}
              {{item.type=='24'?'微信退货':''}}
              {{item.type=='55'?'报名扣积分':''}}
              {{item.type=='66'?'报名赠积分':''}}
            </p>
            <p class="fl">{{item.score}}</p>
          </li>
          <li v-show="noData"><p style="width:100%;">暂无数据!</p></li>
        </ul>
        <div class="member_balance_pages">
          <div>
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="memberScorePage"
              :page-size="20"
              layout="prev, pager, next, jumper"
              :total="this.total">
            </el-pagination>
          </div> 
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import '../../assets/css/reset.css'
import axios from 'axios'
import Qs from 'qs'
import { ip,overtime } from '../../assets/js/public.js'
export default {
  data(){
    return{
      startTime:'',
      endTime:'',
      billType:'',
      moneyFlows:'',
      total:0,
      memberScorePage:1,
      memberScoreList:[],
      score:'',
      overdueScore:'',
      noData:false,
      income:0,
      spending:0
    }
  },
  mounted:function(){
    var t_=this
    t_.getMemberScore(t_.memberScorePage)
  },
  methods:{
    searchFn:function(){
      var t_=this
      if(t_.startTime&&t_.endTime){
        if(parseFloat(t_.startTime.split('-').join(''))>parseFloat(t_.endTime.split('-').join('')))return t_.$message({
          message:'开始时间不能小于结束时间',
          center:true,
          type:'warning'
        })
      }
      t_.memberScorePage=1
      t_.memberScoreList=[]
      this.getMemberScore(t_.memberScorePage)
    },
    handleSizeChange(val){

    },
    handleCurrentChange(val) {
      this.memberScorePage=val
      this.memberScoreList=[]
      this.getMemberScore(val)
    },
    getMemberScore:function(page){
      var t_=this
      var data={
        channel:2,
        tamp:localStorage.tamp?localStorage.tamp:'',
        page:page,
        pagesize:20,
        tenantId:t_.$route.query.tenantId,
        memberCardId:t_.$route.query.memberCardId
      }
      if(t_.startTime)data.startTime=t_.startTime
      if(t_.endTime)data.endTime=t_.endTime
      if(t_.billType)data.type=t_.billType
      if(t_.moneyFlows)data.moneyFlows=t_.moneyFlows
      data=Qs.stringify(data)
      axios.post(`${ip}formWorkInterface/summaryForMemberScore`,data).then(res=>{
        if(overtime(res.data.code)){
          localStorage.removeItem('tamp')
          localStorage.removeItem('name')
          return this.$router.push({
            path: '/LoginHome?state=1',
            query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
          });
          this.$router.go(0);
        }
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code==0){
          if(res.data.rows.length==0){
            t_.noData=true
          }else{
            t_.noData=false
            t_.score=res.data.score
            t_.overdueScore=res.data.overdueScore
            t_.memberScoreList=res.data.rows
            t_.total=res.data.total
            t_.income=res.data.income
            t_.spending=res.data.spending
          }
        }
      })
    },
    getStartTime:function(val){
      this.startTime=val
      
    },
    getEndTime:function(val){
      this.endTime=val
    },
  }
}
</script>
<style>
  .member_balance_box{
    width: 1070px;
  }
  .member_balance_header{
    height: 124px;
    background: #fff;
    padding-top: 25px;
    margin-bottom: 10px;
  }
  .member_balance_header .t1{
    margin-left: 22px;
    font-size: 18px;
    color:#666;
    margin-bottom: 30px;
  }
  .member_balance_header .t2{
    margin-left: 60px;
    font-size: 34px;
    color:#e1251c;
    position: relative;
  }
  .member_balance_search{
    height: 165px;
    padding-top: 13px;
    background: #fff;
    margin-bottom:10px;
  }
  .member_balance_search>ul{
    margin-left: 23px;
    margin-bottom:53px;
  }
  .member_balance_search>ul>li span{
    line-height: 40px;
  }
  .member_balance_search>ul>li button{
    width: 60px;
    height: 32px;
    background: #e4231c;
    border: 0;
    border-radius: 3px;
    color:#fff;
    margin-right: 100px;
    margin-top:4px;
  }
  .el-date-editor.el-input, .el-date-editor.el-input__inner{
    width: 143px;
  }
  .member_balance_search_total .income{
    margin-left: 256px;
    width: 300px;
  }
  .member_balance_search_total .expenditure{
    width: 300px;
  }
  .member_balance_content{
    background: #fff;
  }
  .member_balance_content h2{
    height: 63px;
    border-bottom:1px solid #b0b0b0;
  }
  .member_balance_content h2 p{
    line-height: 63px;
    width: 25%;
    text-align: center;
  }
  .member_balance_content>ul{
    margin-bottom: 10px;
  }
  .member_balance_content>ul>li{
    height: 63px;
    border-bottom: 1px solid #e1e1e1;
  }
  .member_balance_content>ul>li>p{
    width: 25%;
    height: 63px;
    text-align: center;
    line-height: 63px;
  }
  .slash{
    width: 34px;
    height: 34px;
    background: url(../../assets/img/slash.png);
    color:#666;
    display: inline-block;
    top: 3px;
    margin: 0 10px;
    position: relative;
  }
  .member_balance_pages{
    text-align: center;
    padding-bottom: 10px;
  }
  .member_balance_pages .el-pagination__jump{
    margin-top: -9px;
  }
  .member_balance_pages .el-pagination__jump .el-pagination__editor{
    top:9px;
  }
  .el-select__caret{
    margin-top: 39px;
  }
</style>



// WEBPACK FOOTER //
// src/components/member/member_score.vue